// Initialize axios interceptors with store dependencies
// This file exists to break the circular dependency between store and axiosInstance
// It should be imported only after both modules are available

import store from "../store";
import { clearAuth } from "../store/auth/authSlice";
import { registerAuthClearCallback } from "./axiosInstance";

// Register the auth clear callback after store is initialized
registerAuthClearCallback(() => {
  store.dispatch(clearAuth());
});
